import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

type ProviderName = 'blockchain' | 'moonpay';

const DEFAULT_PROVIDER_NAME: ProviderName = 'blockchain';

function useBuyProvider() {
  return useSelector(selectors.fiatRamp.provider) ?? DEFAULT_PROVIDER_NAME;
}

export default useBuyProvider;
